<template>
  <v-container fluid>
    <v-card class="elevation-1" outlined>
      <v-toolbar flat>
        <v-toolbar-title class="headline">
          <v-icon left>fas fa-project-diagram</v-icon>Forge Nano Projects
        </v-toolbar-title>
        <v-spacer/>
        <v-btn :to="{ name: 'ProjectCreateView'}">New Project</v-btn>
        <v-btn icon @click.native="initialize">
          <v-icon>refresh</v-icon>
        </v-btn>
        <template v-slot:extension>
          <v-row class="px-5">
            <v-btn small @click="getArchived" :loading="loading">
            Get Archived
            </v-btn>
            <v-spacer/>
            <v-text-field
            v-model="search"
            prepend-inner-icon="search"
            single-line
            hide-details
            clearable
            />
          </v-row>
        </template>
      </v-toolbar>
      <ProjectsTable :loading="loading" :search="search" :items="projects" />
    </v-card>
  </v-container>
</template>

<script>
import ProjectsTable from "../../components/Project/ProjectsTable";
import ProjectTag from "../../models/ProjectTag";
import Project from "../../models/Project";
export default {
  name: "Projects",
  components: { ProjectsTable },
  data() {
    return {
      loading: true,
      search: ""
    };
  },
  computed: {
    projects() {
      return Project.query()
        .with('tag')
        .with('company')
        .with('user')
        .get()
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      Project.$fetchActive()
          .then(() =>
              ProjectTag.$fetch().then(() =>
                  this.loading = false)
          );
    },
    getArchived() {
      this.loading = true;
      Project.$fetchAll()
        .then(() => (this.loading = false));
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>
